import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37dd7260"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product-center" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = { class: "detail-info" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "en-title" }, "产品中心", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "PRODUCT CENTER", -1))
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "detail" }
const _hoisted_8 = { class: "banner-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardBannerList = _resolveComponent("CardBannerList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.state.name || ''), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.state.companyInfo || ''), 1)
        ]),
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleMore && _ctx.handleMore(...args))),
          class: "btn"
        }, "查看更多")
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_CardBannerList, {
        list: _ctx.state.companyList,
        onOnSwiper: _ctx.onSwiper
      }, null, 8, ["list", "onOnSwiper"])
    ])
  ]))
}